import { useGetTabs } from '@components/App/Modal/SeoPreview/components/Tabs/useGetTabs'
import { Tabs as TabsComponent } from '@lib/components'
import type React from 'react'

export const Tabs: React.FC = () => {
  const tabs = useGetTabs()

  return <TabsComponent tabs={tabs} />
}
